module.exports = __webpack_public_path__ + "static/media/Rotessa-flinks-price-image.8cf8ac59.png";